import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { shallowEqual } from 'react-redux';
import { useScrollLocking } from '../../hooks/useScrollLocking';
import { useAppSelector } from '../../redux/store';
import { CHAT_PANEL_MESSAGES_BACKGROUND_COLOR } from '../../styles/colors';
import { PANEL_CONTENT_WITHOUT_TEXT_HEADER_PADDING_STRING } from '../../styles/styles';
import { MessageInput } from '../messageInput';
import { PANEL_CONTAINER_QUERY_CONTAINER_CLASS_NAME, PanelContainer } from '../panelStyles';
import { ChatItemDisplay } from './chatItemDisplay';
const CHAT_ITEMS_CONTAINER_CSS = css `
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${CHAT_PANEL_MESSAGES_BACKGROUND_COLOR};
  border-radius: 5px 0 0 5px;
  overflow-wrap: break-word; // allow breaking anywhere to avoid horizontal scrollbar
  padding: 2px;
  overscroll-behavior: auto;
`;
export const ChatPanel = ({ messageInputHandler }) => {
    const orderedChatItemIds = useAppSelector((state) => state.chat.orderedItemIds, shallowEqual);
    const isFourColorDeckEnabled = useAppSelector((state) => state.selfData.isFourColorDeckEnabled);
    const [setScrollLockingElementRef, onScroll] = useScrollLocking(orderedChatItemIds);
    return (_jsxs(PanelContainer, { padding: PANEL_CONTENT_WITHOUT_TEXT_HEADER_PADDING_STRING, "aria-label": 'chat panel', children: [_jsx("section", { "aria-label": 'chat messages', ref: setScrollLockingElementRef, onScroll: onScroll, css: CHAT_ITEMS_CONTAINER_CSS, className: PANEL_CONTAINER_QUERY_CONTAINER_CLASS_NAME, children: orderedChatItemIds.map((chatItemId) => (_jsx(ChatItemDisplay, { chatItemId: chatItemId, isFourColorDeckEnabled: isFourColorDeckEnabled }, chatItemId))) }), _jsx(MessageInput, { type: 'chat', messageInputHandler: messageInputHandler, label: 'Chat', sendButtonTitle: 'Send Chat' })] }));
};
